import { Plus } from "lucide-react";
import { RecordContextProvider, useGetList, useTranslate } from "ra-core";
import { Link } from "react-router";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { ListSkeleton } from "../misc/ListSkeleton";
import { useConfigurationContext } from "../root/ConfigurationContext";
import type { Company } from "../types";
import { CompanyAvatar } from "./CompanyAvatar";
import { companyPlace } from "./companyModel";

export const CompanyListMobile = () => {
  const translate = useTranslate();
  const { companySectors } = useConfigurationContext();
  const { data, isPending } = useGetList<Company>("companies", {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "name", order: "ASC" },
  });

  return (
    <>
      <MobileHeader>
        <h1 className="text-2xl font-semibold tracking-tight">
          {translate("resources.companies.name", { smart_count: 2 })}
        </h1>
        <Link
          to="/companies/create"
          aria-label={translate("resources.companies.action.new")}
          className="liquid-glass glass-press ml-auto flex size-9 shrink-0 items-center justify-center rounded-full text-[var(--glass-accent)] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50"
        >
          <Plus className="size-5" strokeWidth={2.25} />
        </Link>
      </MobileHeader>
      <MobileContent>
        {isPending ? (
          <ListSkeleton variant="cards" />
        ) : (
          <div className="flex flex-col gap-3">
            {(data ?? []).map((company) => (
              <RecordContextProvider key={company.id} value={company}>
                <Link
                  to={`/companies/${company.id}/show`}
                  className="flex items-center gap-3 rounded-4xl bg-card px-4 py-3 shadow-card ring-1 ring-border"
                >
                  <CompanyAvatar width={40} />
                  <span className="flex min-w-0 flex-col">
                    <span className="truncate font-medium">{company.name}</span>
                    <span className="truncate text-sm text-muted-foreground">
                      {companyPlace(company, companySectors) ??
                        translate("resources.companies.nb_contacts", {
                          smart_count: company.nb_contacts ?? 0,
                        })}
                    </span>
                  </span>
                </Link>
              </RecordContextProvider>
            ))}
          </div>
        )}
      </MobileContent>
    </>
  );
};
